import type { Alert } from "@tandemdiabetes/sugarmate-api-react-client"
import { useSaveAlert } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useAlerts } from "./useAlerts"
import type { PartialWithId } from "src/types"
import { noticeError } from "src/utils"

export function useUpdateAlert() {
  const saveAlert = useSaveAlert()
  const {
    mutate,
    data: alerts,
  } = useAlerts()

  return useMemo(
    () => saveAlert && (async (updatedAlert: PartialWithId<Alert>) => {
      try {
        const response = await saveAlert(updatedAlert)

        if (alerts) {
          const responseAlert = response.data.alert

          const updatedList = alerts.map((cachedAlert) => {
            if (cachedAlert.id === responseAlert.id) {
              return responseAlert
            }

            return cachedAlert
          })

          void mutate(updatedList)
        } else {
          void mutate()
        }

        return response
      } catch (e) {
        noticeError(
          e,
          "UpdateAlert",
          { alert: updatedAlert },
        )

        throw e
      }
    }),
    [
      saveAlert,
      alerts,
      mutate,
    ],
  )
}
